import { clientApiCall } from "./apiCallWrapper";
import type { AuthPayload, AuthResponse } from "./types/auth";

const withCredentials = { withCredentials: true };

/** Клиентский API авторизации Bitrix bxApi (/auth/*). */
export default (_axios: any, config: any) => ({
  checkUser(phone: string): Promise<AuthResponse | null> {
    return clientApiCall<AuthResponse>(`${config.API_URL}/auth/checkUser`, {
      api: "auth.checkUser",
      method: "post",
      params: {},
      axiosConfig: {
        ...withCredentials,
        params: { phone },
      },
    });
  },

  auth({ phone, code }: AuthPayload): Promise<AuthResponse | null> {
    return clientApiCall<AuthResponse>(`${config.API_URL}/auth/auth`, {
      api: "auth.auth",
      method: "post",
      params: {},
      axiosConfig: {
        ...withCredentials,
        params: { phone, code },
      },
    });
  },

  getCode(phone: string): Promise<AuthResponse | null> {
    return clientApiCall<AuthResponse>(`${config.API_URL}/auth/getCode`, {
      api: "auth.getCode",
      method: "post",
      params: {},
      axiosConfig: {
        ...withCredentials,
        params: { phone },
      },
    });
  },

  getUserCryptoId(): Promise<string | null> {
    return clientApiCall<string>(
      `${config.API_URL}/auth/getUserCryptoId`,
      {
        api: "auth.getUserCryptoId",
        method: "post",
        params: {},
        axiosConfig: withCredentials,
      },
    );
  },

  authByCryptoId(code: string): Promise<AuthResponse | null> {
    return clientApiCall<AuthResponse>(
      `${config.API_URL}/auth/authByCryptoId`,
      {
        api: "auth.authByCryptoId",
        method: "post",
        params: {},
        axiosConfig: {
          ...withCredentials,
          params: { code },
        },
      },
    );
  },
});
